export type IonLabelPlacementType = 'none' | 'start' | 'end';
